module.exports = __webpack_public_path__ + "img/xx@2x.baddd96b.png";